//шкафы
import { modelMeta } from '@/Constants/modelMeta';

export const tc1947FileName = 'models/tc_1947.glb.xz';
export const tc1095FileName = 'models/tc_1095.glb.xz';
export const tc1995FileName = 'models/tc_1995.glb.xz';
export const tc19952FileName = 'models/tc_1995_2.glb.xz';
export const amhtcFileName = 'models/amh_tc.glb.xz';
export const amhtcelFileName = 'models/amh_tc_el.glb.xz';
export const hard1000FileName = 'models/hard_1000.glb.xz';
export const hard2000FileName = 'models/hard_2000.glb.xz';
export const glbCToolChests = [
    tc1947FileName,
    tc1095FileName,
    tc1995FileName,
    tc19952FileName,
    amhtcFileName,
    amhtcelFileName,
    hard1000FileName,
    hard2000FileName,
];
export type tc1947FileName = typeof tc1947FileName;
export type tTc1095FileName = typeof tc1095FileName;
export type tTc1995FileName = typeof tc1995FileName;
export type ttc19952FileName = typeof tc19952FileName;
export type tAmhtcFileName = typeof amhtcFileName;
export type tAmhtcelFileName = typeof amhtcelFileName;
export type tHard1000FileName = typeof hard1000FileName;
export type tHard2000FileName = typeof hard2000FileName;
//комплектующие
export const hardFileName = 'hard.glb.xz';
export const tcFileName = 'tc.glb.xz';
export const amhFileName = 'amh_tc.glb.xz';
export const accessoryFileName = 'accessories.glb.xz';
export const glbComponents = [ hardFileName, tcFileName, amhFileName ];

export type tHardFileName = 'hard.glb.xz';
export type tTcFileName = 'tc.glb.xz';
export type tAmhFileName = 'amh_tc.glb.xz';
export type tAccessoryFileName = 'accessories.glb.xz';

export const getFileNameByBlenderName = (blenderName?: string) => {
    if (!blenderName) {
        console.error('blenderName === undefined');
        return;
    }
    const meta = modelMeta.find(item => item.name === blenderName);
    if (!meta) {
        console.error('не найдено meta для', blenderName);
        return;
    }
    return meta.fileName;
};

export const getComponentsByFileName = (fileName?: string) => {
    if (!fileName) {
        console.error('fileName === undefined');
        return;
    }
    const meta = modelMeta.filter(item => item.fileName === fileName);
    if (!meta) {
        console.error('не найдено meta для', fileName);
        return;
    }
    return meta.map(x => x.name);
};

//соотнесение шкафа с его комплектующими
export const mapComponentsToToolChest = new Map();
mapComponentsToToolChest.set(tc1947FileName, tcFileName);
mapComponentsToToolChest.set(tc1095FileName, tcFileName);
mapComponentsToToolChest.set(tc1995FileName, tcFileName);
mapComponentsToToolChest.set(tc19952FileName, tcFileName);
mapComponentsToToolChest.set(amhtcFileName, amhFileName);
mapComponentsToToolChest.set(amhtcelFileName, amhFileName);
mapComponentsToToolChest.set(hard1000FileName, hardFileName);
mapComponentsToToolChest.set(hard2000FileName, hardFileName);